import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, LogOut, PartyPopper, Clock, AlertTriangle, Mail } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const Verification = () => {
  const navigate = useNavigate();
  const { user, checkAuth, logout } = useAuth();
  const rejected = !!user?.rejected;

  useEffect(() => {
    if (user?.verified) {
      navigate("/decouvrir");
      return;
    }
    const t = setInterval(() => checkAuth?.(), 20000);
    return () => clearInterval(t);
    // eslint-disable-next-line
  }, [user?.verified]);

  return (
    <div className="min-h-screen bg-kora-sand flex flex-col" data-testid="verification-page">
      <header className="text-white" style={{ backgroundColor: "#3b82f6" }}>
        <div className="max-w-md mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ShieldCheck size={20} />
            <span className="font-display font-bold text-lg">Vérification du profil</span>
          </div>
          <button data-testid="verif-logout" onClick={logout} className="text-white/80 hover:text-white"><LogOut size={18} /></button>
        </div>
      </header>

      <div className="flex-1 max-w-md w-full mx-auto px-6 py-10 flex flex-col justify-center">
        {rejected ? (
          <div data-testid="rejection-message" className="rounded-3xl px-6 py-10 text-center shadow-[0_12px_36px_rgba(220,60,40,0.25)] bg-white border-2 border-red-200">
            <div className="w-16 h-16 rounded-full bg-red-50 text-red-500 flex items-center justify-center mx-auto mb-5">
              <AlertTriangle size={30} />
            </div>
            <h1 className="font-display font-black text-xl text-kora-ink leading-snug">
              Votre profil n'a pas été approuvé
            </h1>
            <p className="text-sm text-kora-ink/70 mt-3 leading-relaxed">
              Après vérification, votre profil n'a pas pu être approuvé en l'état. Assurez-vous que vos photos vous
              représentent réellement et que vos informations sont exactes.
            </p>
            <button
              data-testid="rejection-contact-btn"
              onClick={() => navigate("/contact")}
              className="mt-6 inline-flex items-center gap-2 bg-kora-terracotta text-white font-bold rounded-full px-6 py-3"
            >
              <Mail size={16} /> Nous contacter
            </button>
          </div>
        ) : (
          <div data-testid="congrats-message" className="rounded-3xl px-6 py-12 text-center shadow-[0_16px_44px_rgba(38,120,72,0.3)]" style={{ backgroundColor: "#1F7A4D" }}>
            <div className="w-16 h-16 rounded-full bg-white/15 text-white flex items-center justify-center mx-auto mb-6">
              <PartyPopper size={30} />
            </div>
            <h1 className="font-display font-black text-2xl leading-snug text-white">
              Félicitations pour votre inscription !
            </h1>
            <p className="text-base mt-4 leading-relaxed font-semibold" style={{ color: "#DFF3E7" }}>
              Un message de confirmation vous sera envoyé dans les minutes qui suivent après vérification de votre profil.
            </p>
            <div className="mt-8 inline-flex items-center gap-2 bg-white/15 text-white text-sm font-bold rounded-full px-5 py-2.5">
              <Clock size={16} className="animate-pulse" /> Vérification en cours…
            </div>
          </div>
        )}
        <p className="text-center text-xs text-kora-muted mt-6">
          Cette page se mettra à jour automatiquement dès que votre profil sera vérifié.
        </p>
      </div>
    </div>
  );
};

export default Verification;
